import API from '../api/api'

export const state = () => ({
  data: {},
  loading: true,
  error: null
})

export const mutations = {
  set (state, data) {
    state.data = data
    state.loading = false
  }
}

// In-flight plain (param-less) profile request. Only ever set client-side:
// every getUser dispatch site is process.client-guarded or a client-mode
// plugin, so this never leaks state across SSR requests.
let pendingRequest = null

export const actions = {
  getUser ({ commit, state }, params) {
    const hasParams = params && Object.keys(params).length > 0

    // Plain fetches all want the same thing, so reuse loaded or in-flight
    // data instead of hitting /profile again (the clarity-identify plugin
    // fetches at init; the packages components fetch again on mount).
    // Calls with params (foretell create/utm) always go through untouched.
    if (!hasParams) {
      if (state.data && state.data.id) {
        return Promise.resolve()
      }
      if (pendingRequest) {
        return pendingRequest
      }
    }

    const request = API.user.getUser(this.$axios, params)
      .then((data) => {
        commit("set", data)
      })
      .catch(() => {
        commit("set", {})
      })

    if (!hasParams) {
      pendingRequest = request.then(() => {
        pendingRequest = null
      })
      return pendingRequest
    }
    return request
  }
}